module.exports = __webpack_public_path__ + "static/img/banner2.27ed4e5a.png";